import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EmailLogsModel } from "common/models/page-models/email-logs/email-logs-data-model";
import { EmailLogsListingModel } from "common/models/page-models/email-logs/email-logs-grid-model";
import { GridResolver } from "common/resolvers/core-resolvers/grid.resolver";
import { SystemService } from "common/services/core-services/system.service";
import { EmailLogsWidgetService } from "common/widget/email-logs/email-logs-widget.service";

@Injectable({
    providedIn: 'root'
})

export class EmailLogsGridResolver extends GridResolver<EmailLogsModel, EmailLogsListingModel> {
    constructor(
        protected fs: EmailLogsWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override createQueryParams(paramsData: any): any {
        paramsData.pageNumber = 1;
        paramsData.pageSize = 10;
        return paramsData;
      }
    
}